export default __webpack_public_path__ + "static/future-icn-13f163819d593a76ad3d712c72db6e35.png";